var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.quota)?_c('b-alert',{staticClass:"mb-0",attrs:{"variant":"info","show":""}},[_vm._v(_vm._s(_vm.quota))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }